import { useEffect, useState } from "react";
import { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDatePicker from "../CustomDatePicker";
import { Box, Button } from "@mui/material";

const DateFilter = () => {
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const navigate = useNavigate();
  const { search } = useLocation()

  const todayDateFilter = () => {
    setStartDate(null);
    setEndDate(null);
    const today = dayjs();
    const nextDay = today.add(1, "day");
    const todayFormatted = today.format("YYYY-MM-DD");
    const nextDayFormatted = nextDay.format("YYYY-MM-DD");
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("start_date", todayFormatted);
    searchParams.set("end_date", nextDayFormatted);
    navigate(`?${searchParams.toString()}`);
  };

  useEffect(() => {
    if (startDate && endDate) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("start_date", startDate.format("YYYY-MM-DD"));
      searchParams.set("end_date", endDate.format("YYYY-MM-DD"));
      navigate(`?${searchParams.toString()}`);
    } else if (!startDate && !endDate) {
      navigate("?page=1");
    }
  }, [startDate, endDate, navigate]);

  useEffect(()=>{
    const searchParams = new URLSearchParams(window.location.search);
    if(searchParams.get('start_date') === null && searchParams.get('end_date') === null){
      setStartDate(null)
      setEndDate(null)
    }
  },[search,setStartDate,setEndDate])

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: {xs: 'center', md: 'flex-end'} }}>
      <CustomDatePicker
        label={"Start Date"}
        date={startDate}
        setDate={setStartDate}
        error={""}
        sx={{ mr: 1 }}
      />
      <CustomDatePicker
        label={"End Date"}
        date={endDate}
        setDate={setEndDate}
        error={""}
        sx={{ marginLeft: 1 }}
      />
      <Button
        onClick={() => todayDateFilter()}
        sx={{ height: "100%", ml: 2 }}
        variant="outlined"
      >
        Today
      </Button>
    </Box>
  );
};

export default DateFilter;
